import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./Player.css";

const Player = (props) => {
  const handleAddPlayer = props.handleAddPlayer;
  const { country, name, number, img, money } = props.player;
  return (
    <div className="d-flex player pb-3 pt-3">
      <div className="player-image">
        <img className="rounded ml3" src={img} alt="" />
      </div>
      <div className="player-details text-center d-flex justify-content-center align-items-center">
        <div className="">
          <h4>Name: {name}</h4>
          <p>Number: {number}</p>
          <p>Country: {country}</p>
          <p>Salary: ${money}</p>
          <button
            onClick={() => handleAddPlayer(props.player)}
            className="btn btn-primary mt-5"
          >
            <FontAwesomeIcon className="icn" icon={faCheck} />
            Select
          </button>
        </div>
      </div>
    </div>
  );
};

export default Player;
